import React, {ReactElement, useEffect, useState} from 'react';
import {useHistory} from 'react-router';
import {setTourGuide} from '../../redux/tourGuideSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import NavigationDrawerContainer from '../../containers/NavigationDrawerContainer';
import HomeSideBar from '../../components/sidebar/HomeSideBar';
import {
  upperSideNavMenus,
  lowerSideNavMenus,
  APP_ROUTES,
} from './../../lib/constants';
import {sideNavMenuType} from '../../lib/types';
import eliteIcon from './../../assets/images/elite.svg';
import {getUser} from '../../core/localstorage-data';
import {logout} from '../../core/utils/routing.util';
import {HOME_ROUTE_PATH} from '../../routes/route-constants';
//import {HOME_ROUTE_PATH} from '../../routes/route-constants';
let deferredPrompt:any;



const Home = ({children}: {children: React.ReactNode}): ReactElement => {
  const UserData = getUser();
  const dispatch = useAppDispatch();
  //  const navigate = useHistory();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const history = useHistory();
  const [firstName, setFirstName] = useState('');
  const [installable, setInstallable] = useState(false);
  

  

  useEffect(() => {
    if (UserData?.firstName != null) {
      const name = UserData.firstName.split(' ');
      //      const rest = name.substring(0, name.lastIndexOf(' ') + 1);
      //    const lastName = name.substring(name.lastIndexOf(' ') + 1, name.length);
      //  console.log(rest);
      //console.log(lastName);

      //console.log(rest);
      setFirstName(name[0]);
    }
  }, [UserData]);
  const handleInstallClick = (e:any) => {
    // Hide the app provided install promotion
    setInstallable(false);
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult: { outcome: string; }) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
    });
};
useEffect(() => {
  window.addEventListener("beforeinstallprompt", (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    console.log(e);
    // Update UI notify the user they can install the PWA
    setInstallable(true);
  });

  window.addEventListener('appinstalled', () => {
    // Log install to analytics
    console.log('INSTALL: Success');
  });
}, []);

  const onCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const menuClickHandler = (menu: sideNavMenuType) => {
    onCloseDrawer();
    if (menu.type === 'link' && menu.url !== '') {
      history.push(menu.url);
    } else if (menu.type === 'link' && menu.link != '' && menu.target != '') {
      window.open('https://wa.link/8ht2dn', '_blank');
    } else if (menu.url === APP_ROUTES.LOGOUT) {
      logout();
    } else if (menu.url === APP_ROUTES.TAKE_A_TOUR) {
      console.log('aa');
      dispatch(setTourGuide(true));

      //  history.push(HOME_ROUTE_PATH);
      //window.location.reload(false);
      history.push(HOME_ROUTE_PATH);
    }
  };

  const getMenuText = (menu: sideNavMenuType): React.ReactNode => {
    if (menu.name === 'Benefit from ELITE') {
      return (
        <div className="flex pr-2">
          <span className="pr-4">{menu.name}</span>
          <span className="mt-1">
            <img src={eliteIcon} alt="Benefit from ELITE" />
          </span>
        </div>
      );
    } else {
      return <>{menu.name}</>;
    }
  };

  const sidebarContent: React.ReactNode = (
    <HomeSideBar open={isDrawerOpen} onClose={onCloseDrawer}>
      <React.Fragment>
        <div className="absolute w-full top-0 bottom-24 overflow-y-auto">
          <div className="block h-16 flex items-center py-4 px-8 text-white cursor-pointer bg-blue_zero text-xl">
            Hello!&nbsp;
            <span className="font-semibold overflow-ellipsis overflow-hidden">
              {firstName}
            </span>
            &nbsp;
          </div>
          <div>
            {upperSideNavMenus.map((menu, index) => (
              <a
                className="block h-12 py-4 px-8 cursor-pointer font-semibold"
                key={index}
                onClick={() => menuClickHandler(menu)}>
                {getMenuText(menu)}
              </a>
            ))}
          </div>
          <div className="mt-2">
            {lowerSideNavMenus.map((menu, index) => (
              <a
                className="block h-12 py-4 px-8 cursor-pointer text-sm"
                key={index}
                onClick={() => menuClickHandler(menu)}>
                {menu.name}
              </a>
            ))}
          </div>
        </div>
        <div className="bg-blue_four flex items-center absolute bottom-0 left-0 right-0 block w-full h-23 text-white px-4 py-2 cursor-pointer">
          <button className="secondary normal px-4 py-2.5 font-bold w-full text-small" onClick={handleInstallClick}>
            Add Buddy Shortcut to your Mobile
          </button>
        </div>
      </React.Fragment>
    </HomeSideBar>
  );

  const drawerClickAction = () => {
    console.log('exec drawerClickAction');
    setIsDrawerOpen(prevState => !prevState);
  };

  return (
    <NavigationDrawerContainer
      sidebarContent={sidebarContent}
      onDrawerButtonClicked={drawerClickAction}>
      {children}
    </NavigationDrawerContainer>
  );
};

export default Home;
